export const printBill = (order, type = 'payment', paymentDetails = {}) => {
    if (!order) return;

    // Formatting helpers
    const formatDate = (dateString) => {
        const d = new Date(dateString || Date.now());
        const day = d.getDate().toString().padStart(2, '0');
        const monthMatch = d.toLocaleString('en-GB', { month: 'short' });
        const year = d.getFullYear();
        const timeMatch = d.toLocaleString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });
        
        return `${day} ${monthMatch} ${year} ${timeMatch}`;
    };

    const formatLKR = (amount) => {
        return Number(amount || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    const dashedLine = `<div style="border-bottom: 1px dashed #000; margin: 4px 0;"></div>`;
    const getLogoUrl = () => {
        return `${window.location.origin}/assets/img/bill_logo.png`;
    };

    let itemsRows = '';
    
    if (type === 'kot') {
        itemsRows = order.items.map(item => `
            <tr>
                <td style="padding: 4px 0; vertical-align: top; max-width: 180px;">
                    <div style="font-size: 10pt; text-transform: uppercase; font-family: monospace;">${item.productName}</div>
                    ${item.variationName ? `<div style="font-size: 10pt; margin-left: 5px;">- ${item.variationName}</div>` : ''}
                    ${item.notes ? `<div style="font-size: 10pt; margin-left: 5px;">Note: ${item.notes}</div>` : ''}
                </td>
                <td style="padding: 4px 0; text-align: right; vertical-align: top; font-size: 10pt; font-weight: bold; width: 60px;">
                    ${Number(item.quantity).toFixed(3)}
                </td>
            </tr>
        `).join('');
    } else {
        itemsRows = order.items.map(item => `
            <tr>
                <td colspan="3" style="padding: 4px 0 2px 0; font-size: 10pt; text-transform: uppercase; font-family: monospace;">
                    ${item.productName}
                </td>
            </tr>
            <tr>
                <td style="padding: 0 0 4px 0; font-size: 10pt; font-family: monospace;">
                    LKR ${formatLKR(item.price)}
                </td>
                <td style="padding: 0 0 4px 0; font-size: 10pt; text-align: center; font-family: monospace; width: 60px;">
                    ${Number(item.quantity).toFixed(3)}
                </td>
                <td style="padding: 0 0 4px 0; font-size: 10pt; text-align: right; font-family: monospace; width: 90px;">
                    ${formatLKR(item.total)}
                </td>
            </tr>
        `).join('');
    }

    const htmlContent = `<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8"/>
  <title>${type === 'kot' ? 'KOT' : 'Receipt'}</title>
  <style>
    @page { size: 80mm auto; margin: 0; }
    * { margin: 0; padding: 0; box-sizing: border-box; }
    body {
      font-family: 'Courier New', Courier, monospace;
      color: #000;
      width: 80mm;
      padding: 0 5mm 5mm 5mm;
      max-width: 300px;
      margin: 0 auto;
    }
    .center { text-align: center; }
    .bold { font-weight: bold; }
    .row { display: flex; justify-content: space-between; }
  </style>
</head>
<body>
  <div class="center" style="margin-bottom: 5px;">
    ${type !== 'kot' ? `
    <img src="${getLogoUrl()}" style="max-width: 120px; margin-bottom: 5px; filter: grayscale(100%);" alt="Logo" onerror="this.style.display='none'" />
    <div style="font-size: 10pt; font-family: monospace; margin-bottom: 2px;">Dharmapala Mawatha, Rambukkana</div>
    <div style="font-size: 10pt; font-family: monospace; font-weight: bold; margin-bottom: 2px;">+94 77 536 7088</div>
    <div style="font-size: 10pt; font-family: monospace; margin-bottom: 2px;">Avastarhotel@gmail.com</div>
    ` : ''}
  </div>
  
  ${dashedLine}
  
  <div style="font-size: 11pt; font-weight: bold; text-transform: uppercase; font-family: monospace; margin: 4px 0;">
    ${order.orderType || 'ORDER'} ${order.kotNumber || ''}
  </div>
  
  <div style="font-size: 10pt; font-family: monospace; margin-bottom: 2px;">Invoice No:${order.orderId || '-'}</div>
  <div style="font-size: 10pt; font-family: monospace; margin-bottom: 2px;">Terminal ID: 1</div>
  ${order.tableNumber && order.orderType === 'Dine-in' ? `<div style="font-size: 10pt; font-family: monospace; margin-bottom: 2px;">Table No: ${order.tableNumber}</div>` : ''}
  <div style="font-size: 10pt; font-family: monospace; margin-bottom: 4px;">Printed Date:${formatDate(new Date())}</div>
  
  ${dashedLine}

  ${type === 'payment' ? `
  <table style="width: 100%; border-collapse: collapse;">
    <thead>
      <tr>
        <th style="text-align: left; padding: 2px 0; font-size: 11pt; font-family: monospace; font-weight: bold;">Description & Price</th>
        <th style="text-align: center; padding: 2px 0; font-size: 11pt; font-family: monospace; font-weight: bold; width: 60px;">Qty</th>
        <th style="text-align: right; padding: 2px 0; font-size: 11pt; font-family: monospace; font-weight: bold; width: 90px;">Total</th>
      </tr>
    </thead>
    <tbody>
       <tr><td colspan="3">${dashedLine}</td></tr>
       ${itemsRows}
    </tbody>
  </table>
  ` : `
  <table style="width: 100%; border-collapse: collapse;">
    <thead>
      <tr>
        <th style="text-align: left; padding: 2px 0; font-size: 11pt; font-family: monospace; font-weight: bold;">Description</th>
        <th style="text-align: right; padding: 2px 0; font-size: 11pt; font-family: monospace; font-weight: bold; width: 60px;">Qty</th>
      </tr>
    </thead>
    <tbody>
       <tr><td colspan="2">${dashedLine}</td></tr>
       ${itemsRows}
    </tbody>
  </table>
  `}
  
  ${dashedLine}

  ${type === 'payment' ? `
  <div style="margin-top: 5px;">
    <div style="font-size: 11pt; font-family: monospace; margin-bottom: 2px;">
      Sub Total :${formatLKR(order.subTotal)}
    </div>
    ${(order.discount || paymentDetails.discount) ? `
      <div style="font-size: 10pt; font-family: monospace; margin-bottom: 2px;">
        Discount  :-${formatLKR(order.discount || paymentDetails.discount)}
      </div>
    ` : ''}
    <div style="font-size: 12pt; font-weight: bold; font-family: monospace; margin-top: 2px;">
      GrandTotal:${formatLKR(order.grandTotal - (paymentDetails.discount || 0))}
    </div>
  </div>

  <div class="center" style="margin-top: 15px; margin-bottom: 10px;">
    <span style="font-size: 10pt; font-family: monospace;">********* Payments *********</span>
  </div>

  <div style="font-size: 10pt; font-family: monospace;">
    ${paymentDetails.method || 'Card(LKR)'} :${formatLKR(order.grandTotal - (paymentDetails.discount || 0))}
  </div>

  <div class="center" style="margin-top: 20px; font-size: 10pt; font-family: monospace; font-weight: bold;">
    --No Exchange or Refunds--<br/><br/>
    Thank You, Come Again !!!
  </div>
  
  <div class="center" style="margin-top: 15px; font-size: 9pt; font-family: monospace; font-weight: normal;">
    Developed By Mastersoft Software solutions<br/>
    Hotline +94 78 586 6296
  </div>
  ` : `
  <div class="center" style="margin-top: 15px; font-size: 9.5pt; font-weight: bold; font-family: monospace; border: 2px solid #000; padding: 5px; border-radius: 5px;">
    -- KITCHEN COPY --
  </div>
  `}
  
</body>
</html>`;

    const iframe = document.createElement('iframe');
    iframe.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:none;';
    document.body.appendChild(iframe);
    const doc = iframe.contentWindow.document;
    doc.open();
    doc.write(htmlContent);
    doc.close();
    iframe.contentWindow.focus();
    setTimeout(() => {
        iframe.contentWindow.print();
        setTimeout(() => document.body.removeChild(iframe), 2000);
    }, 500);
};
